// import { useEffect, useState } from "react";
// import { Col, Form, Input, InputNumber, Row, Spin } from "antd";
// import { editSettings, getSettings } from "../../Network";
// import { toastError, toastSuccess } from "../../helpers/toasters";

// import Header from "modules/SubComponents/Header";
// import PrimaryButton from "modules/SubComponents/Buttons/PrimaryButton";

// const Settings = () => {
//   const [loading, setLoading] = useState(true);
//   const [data, setData] = useState([]);
//   const [isWhatsAppSubmitting, setIsWhatsAppSubmitting] = useState(false);
//   const [isCommissionSubmitting, setIsCommissionSubmitting] = useState(false);
//   const [isPeriodSubmitting, setIsPeriodSubmitting] = useState(false);
//   const [isPurchaseLimitSubmitting, setIsPurchaseLimitSubmitting] =
//     useState(false);
//   const [
//     isMonthlyPurchaseLimitSubmitting,
//     setIsMonthlyPurchaseLimitSubmitting,
//   ] = useState(false);
//   const [
//     isMonthlyPurchaseLimitForSalesSubmitting,
//     setIsMonthlyPurchaseLimitForSalesSubmitting,
//   ] = useState(false);
//   const [commissionForm] = Form.useForm();
//   const [whatsAppForm] = Form.useForm();
//   const [receivingPeriodForm] = Form.useForm();
//   const [purchaseLimitForm] = Form.useForm();
//   const [monthlyPurchaseLimitForm] = Form.useForm();
//   const [monthlyPurchaseLimitForSalesForm] = Form.useForm();

//   const handlePreventLetters = (e, allowFloat = true) => {
//     if (
//       e.key === "Backspace" ||
//       (e.key === "." && allowFloat) ||
//       (e.key.startsWith("Arrow") &&
//         (e.key.startsWith("ArrowLeft") || e.key.startsWith("ArrowRight")))
//     )
//       return;
//     if (/\D+/gi.test(e.key)) {
//       e.preventDefault();
//     }
//   };

//   const validatePhoneNumber = (phone) => {
//     let phoneLen = 11;
//     let charLen = 2; // will validate that user enters 0 and first two numbers inputed are 01
//     if (phone.startsWith("2")) {
//       phoneLen = 12;
//       charLen = 3; // will validate that user entered 2 and first two number inputed are 0 and 1
//     }
//     if (
//       phone.length > phoneLen ||
//       (phone.length >= charLen &&
//         !phone.startsWith(`${charLen === 2 ? "0" : "20"}1`)) ||
//       (phone.length >= charLen + 1 &&
//         !phone.startsWith(`${charLen === 2 ? "0" : "20"}10`) &&
//         !phone.startsWith(`${charLen === 2 ? "0" : "20"}11`) &&
//         !phone.startsWith(`${charLen === 2 ? "0" : "20"}12`) &&
//         !phone.startsWith(`${charLen === 2 ? "0" : "20"}15`)) ||
//       phone.length < phoneLen
//     ) {
//       return false;
//     } else {
//       return true;
//     }
//   };

//   const validatePeriod = (_, value) => {
//     if (!value && value !== 0) {
//       return Promise.reject(new Error("Please, Enter the receiving period"));
//     } else if (value <= 0) {
//       return Promise.reject(new Error("Please, Enter a valid period"));
//     } else {
//       return Promise.resolve();
//     }
//   };
//   const validateCommission = (_, value) => {
//     if (!value && value !== 0) {
//       return Promise.reject(new Error("Please, Enter the commission"));
//     } else if (value <= 0 || value > 100) {
//       return Promise.reject(new Error("Please, Enter a valid commission"));
//     } else {
//       return Promise.resolve();
//     }
//   };

//   const validatePurchaseLimit = (_, value) => {
//     if (!value && value !== 0) {
//       return Promise.reject(
//         new Error("Please, Enter the available purchase limit"),
//       );
//     } else if (value <= 0) {
//       return Promise.reject(new Error("Please, Enter a valid purchase limit"));
//     } else {
//       return Promise.resolve();
//     }
//   };

//   const validateMonthlyPurchaseLimit = (_, value) => {
//     if (!value && value !== 0) {
//       return Promise.reject(
//         new Error("Please, Enter the monthly purchase limit"),
//       );
//     } else if (value <= 0) {
//       return Promise.reject(
//         new Error("Please, Enter a valid monthly purchase limit"),
//       );
//     } else {
//       return Promise.resolve();
//     }
//   };

//   const validateMonthlyPurchaseLimitForSales = (_, value) => {
//     if (!value && value !== 0) {
//       return Promise.reject(
//         new Error("Please, Enter the monthly purchase limit for sales"),
//       );
//     } else if (value <= 0) {
//       return Promise.reject(
//         new Error("Please, Enter a valid monthly purchase limit for sales"),
//       );
//     } else {
//       return Promise.resolve();
//     }
//   };

//   const validateMobileNumber = (_, value) => {
//     if (!value) {
//       return Promise.reject(new Error("Please, Enter the whats app number"));
//     } else if (!validatePhoneNumber(value)) {
//       return Promise.reject(
//         new Error("Please, Enter a valid whats app number"),
//       );
//     } else {
//       return Promise.resolve();
//     }
//   };

//   const handleSubmitWhatsApp = (values) => {
//     if (isWhatsAppSubmitting || loading) return;
//     setIsWhatsAppSubmitting(true);

//     const id = data.find((ele) => ele.key === "WhatsAppNumber")?.id;
//     const payload = {
//       id,
//       value: values.whatsAppNumber,
//     };
//     editSettings(
//       payload,
//       (res) => {
//         setIsWhatsAppSubmitting(false);
//         if (res.success) {
//           toastSuccess(res.message);
//         } else {
//           toastError(res.message);
//         }
//       },
//       (res) => {
//         setIsWhatsAppSubmitting(false);
//         toastError(res.message);
//       },
//     );
//   };

//   const handleSubmitCommission = (values) => {
//     if (isCommissionSubmitting || loading) return;
//     setIsCommissionSubmitting(true);

//     const id = data.find(
//       (ele) => ele.key === "GreenMatterPercentageForStoring",
//     )?.id;
//     const payload = {
//       id,
//       value: values.commission.toString(),
//     };
//     editSettings(
//       payload,
//       (res) => {
//         setIsCommissionSubmitting(false);
//         if (res.success) {
//           toastSuccess(res.message);
//         } else {
//           toastError(res.message);
//         }
//       },
//       (res) => {
//         setIsCommissionSubmitting(false);
//         toastError(res.message);
//       },
//     );
//   };
//   const handleSubmitPeriod = (values) => {
//     if (isPeriodSubmitting || loading) return;
//     setIsPeriodSubmitting(true);

//     const id = data.find(
//       (ele) => ele.key === "Add balance to buy and supply supply wallet period",
//     )?.id;
//     const payload = {
//       id,
//       value: values.receivingPeriod.toString(),
//     };
//     editSettings(
//       payload,
//       (res) => {
//         setIsPeriodSubmitting(false);
//         if (res.success) {
//           toastSuccess(res.message);
//         } else {
//           toastError(res.message);
//         }
//       },
//       (res) => {
//         setIsPeriodSubmitting(false);
//         toastError(res.message);
//       },
//     );
//   };

//   const handleSubmitPurchaseLimit = (values) => {
//     if (isPurchaseLimitSubmitting || loading) return;
//     setIsPurchaseLimitSubmitting(true);

//     const id = data.find((ele) => ele.key === "Available Purchase Limit")?.id;
//     const payload = {
//       id,
//       value: values.purchaseLimit.toString(),
//     };
//     editSettings(
//       payload,
//       (res) => {
//         setIsPurchaseLimitSubmitting(false);
//         if (res.success) {
//           toastSuccess(res.message);
//         } else {
//           toastError(res.message);
//         }
//       },
//       (res) => {
//         setIsPurchaseLimitSubmitting(false);
//         toastError(res.message);
//       },
//     );
//   };

//   const handleSubmitMonthlyPurchaseLimit = (values) => {
//     if (isMonthlyPurchaseLimitSubmitting || loading) return;
//     setIsMonthlyPurchaseLimitSubmitting(true);

//     const id = data.find((ele) => ele.key === "Monthly Purchase Limit")?.id;
//     const payload = {
//       id,
//       value: values.monthlyPurchaseLimit.toString(),
//     };
//     editSettings(
//       payload,
//       (res) => {
//         setIsMonthlyPurchaseLimitSubmitting(false);
//         if (res.success) {
//           toastSuccess(res.message);
//         } else {
//           toastError(res.message);
//         }
//       },
//       (res) => {
//         setIsMonthlyPurchaseLimitSubmitting(false);
//         toastError(res.message);
//       },
//     );
//   };

//   const handleSubmitMonthlyPurchaseLimitForSales = (values) => {
//     if (isMonthlyPurchaseLimitForSalesSubmitting || loading) return;
//     setIsMonthlyPurchaseLimitForSalesSubmitting(true);

//     const id = data.find(
//       (ele) => ele.key === "Monthly Purchase Limit For Sales",
//     )?.id;
//     const payload = {
//       id,
//       value: values.monthlyPurchaseLimitForSales.toString(),
//     };
//     editSettings(
//       payload,
//       (res) => {
//         setIsMonthlyPurchaseLimitForSalesSubmitting(false);
//         if (res.success) {
//           toastSuccess(res.message);
//         } else {
//           toastError(res.message);
//         }
//       },
//       (res) => {
//         setIsMonthlyPurchaseLimitForSalesSubmitting(false);
//         toastError(res.message);
//       },
//     );
//   };

//   useEffect(() => {
//     setLoading(true);
//     getSettings(
//       (res) => {
//         setLoading(false);
//         if (res.success) {
//           const whatsNumber = res.data.find(
//             (ele) => ele.key === "WhatsAppNumber",
//           )?.value;
//           whatsAppForm.setFieldsValue({
//             whatsAppNumber: whatsNumber,
//           });
//           const commission = res.data.find(
//             (ele) => ele.key === "GreenMatterPercentageForStoring",
//           )?.value;
//           commissionForm.setFieldsValue({
//             commission: commission,
//           });
//           const receivingPeriod = res.data.find(
//             (ele) =>
//               ele.key === "Add balance to buy and supply supply wallet period",
//           )?.value;
//           receivingPeriodForm.setFieldsValue({
//             receivingPeriod: receivingPeriod,
//           });
//           const purchaseLimit = res.data.find(
//             (ele) => ele.key === "Available Purchase Limit",
//           )?.value;
//           purchaseLimitForm.setFieldsValue({
//             purchaseLimit: purchaseLimit,
//           });
//           const monthlyPurchaseLimit = res.data.find(
//             (ele) => ele.key === "Monthly Purchase Limit",
//           )?.value;
//           monthlyPurchaseLimitForm.setFieldsValue({
//             monthlyPurchaseLimit: monthlyPurchaseLimit,
//           });
//           const monthlyPurchaseLimitForSales = res.data.find(
//             (ele) => ele.key === "Monthly Purchase Limit For Sales",
//           )?.value;
//           monthlyPurchaseLimitForSalesForm.setFieldsValue({
//             monthlyPurchaseLimitForSales: monthlyPurchaseLimitForSales,
//           });
//           setData(res.data);
//         } else {
//           toastError(res.message);
//         }
//       },
//       (res) => {
//         setLoading(false);
//         toastError(res.message);
//       },
//     );
//   }, []);

//   return (
//     <section className="users">
//       <div className="users__all-contents">
//         <div className="users__content">
//           <div className="users__usersData align-items-stretch">
//             <Header title="Settings" />
//             <Spin className="w-100 d-block" spinning={loading}>
//               <section className="mb-5">
//                 <Form
//                   form={commissionForm}
//                   className="px-lg-5 px-2"
//                   onFinish={handleSubmitCommission}
//                   initialValues={{ commission: "" }}
//                 >
//                   <Row gutter={24}>
//                     <Col span={24}>
//                       <div className="new-actor__name new-category mb-5">
//                         <div className="lang-name wd-100 flex ">
//                           <label
//                             className="users__parent-info-label mb-2"
//                             htmlFor=""
//                           >
//                             Commission Percentage
//                           </label>
//                         </div>
//                         <Form.Item
//                           className="new-category__form-item"
//                           name="commission"
//                           rules={[{ validator: validateCommission }]}
//                         >
//                           <InputNumber
//                             className="w-100 d-block search__searchField py-2"
//                             placeholder="Enter commission percentage"
//                             onKeyDown={handlePreventLetters}
//                             controls={false}
//                             keyboard={false}
//                           />
//                         </Form.Item>
//                       </div>
//                     </Col>
//                     <Col span={24}>
//                       <PrimaryButton
//                         buttonName={"Submit"}
//                         loading={isCommissionSubmitting}
//                         type="submit"
//                         disableMe={loading}
//                       />
//                     </Col>
//                   </Row>
//                 </Form>
//               </section>
//               <section className="mb-5">
//                 <Form
//                   form={whatsAppForm}
//                   className="px-lg-5 px-2"
//                   onFinish={handleSubmitWhatsApp}
//                   initialValues={{ whatsAppNumber: "" }}
//                 >
//                   <Row gutter={24}>
//                     <Col span={24}>
//                       <div className="new-actor__name new-category mb-5">
//                         <div className="lang-name wd-100 flex ">
//                           <label
//                             className="users__parent-info-label mb-2"
//                             htmlFor=""
//                           >
//                             Whats App Number
//                           </label>
//                         </div>
//                         <Form.Item
//                           className="new-category__form-item"
//                           name="whatsAppNumber"
//                           rules={[{ validator: validateMobileNumber }]}
//                         >
//                           <Input
//                             className="w-100 d-block search__searchField py-2"
//                             placeholder="Enter whats app number"
//                             onKeyDown={(e) => handlePreventLetters(e, false)}
//                           />
//                         </Form.Item>
//                       </div>
//                     </Col>
//                     <Col span={24}>
//                       <PrimaryButton
//                         buttonName={"Submit"}
//                         loading={isWhatsAppSubmitting}
//                         type="submit"
//                         disableMe={loading}
//                       />
//                     </Col>
//                   </Row>
//                 </Form>
//               </section>
//               <section className="mb-5">
//                 <Form
//                   form={receivingPeriodForm}
//                   className="px-lg-5 px-2"
//                   onFinish={handleSubmitPeriod}
//                   initialValues={{ period: "" }}
//                 >
//                   <Row gutter={24}>
//                     <Col span={24}>
//                       <div className="new-actor__name new-category mb-5">
//                         <div className="lang-name wd-100 flex ">
//                           <label
//                             className="users__parent-info-label mb-2"
//                             htmlFor=""
//                           >
//                             Add balance to buy and supply supply wallet period
//                           </label>
//                         </div>
//                         <Form.Item
//                           className="new-category__form-item"
//                           name="receivingPeriod"
//                           rules={[{ validator: validatePeriod }]}
//                         >
//                           <Input
//                             className="w-100 d-block search__searchField py-2"
//                             placeholder="Enter whats app number"
//                             onKeyDown={(e) => handlePreventLetters(e, false)}
//                           />
//                         </Form.Item>
//                       </div>
//                     </Col>
//                     <Col span={24}>
//                       <PrimaryButton
//                         buttonName={"Submit"}
//                         loading={isPeriodSubmitting}
//                         type="submit"
//                         disableMe={loading}
//                       />
//                     </Col>
//                   </Row>
//                 </Form>
//               </section>
//               <section className="mb-5">
//                 <Form
//                   form={purchaseLimitForm}
//                   className="px-lg-5 px-2"
//                   onFinish={handleSubmitPurchaseLimit}
//                   initialValues={{ purchaseLimit: "" }}
//                 >
//                   <Row gutter={24}>
//                     <Col span={24}>
//                       <div className="new-actor__name new-category mb-5">
//                         <div className="lang-name wd-100 flex ">
//                           <label
//                             className="users__parent-info-label mb-2"
//                             htmlFor=""
//                           >
//                             Available Purchase Limit
//                           </label>
//                         </div>
//                         <Form.Item
//                           className="new-category__form-item"
//                           name="purchaseLimit"
//                           rules={[{ validator: validatePurchaseLimit }]}
//                         >
//                           <InputNumber
//                             className="w-100 d-block search__searchField py-2"
//                             placeholder="Enter available purchase limit"
//                             onKeyDown={handlePreventLetters}
//                             controls={false}
//                             keyboard={false}
//                           />
//                         </Form.Item>
//                       </div>
//                     </Col>
//                     <Col span={24}>
//                       <PrimaryButton
//                         buttonName={"Submit"}
//                         loading={isPurchaseLimitSubmitting}
//                         type="submit"
//                         disableMe={loading}
//                       />
//                     </Col>
//                   </Row>
//                 </Form>
//               </section>
//               <section className="mb-5">
//                 <Form
//                   form={monthlyPurchaseLimitForm}
//                   className="px-lg-5 px-2"
//                   onFinish={handleSubmitMonthlyPurchaseLimit}
//                   initialValues={{ monthlyPurchaseLimit: "" }}
//                 >
//                   <Row gutter={24}>
//                     <Col span={24}>
//                       <div className="new-actor__name new-category mb-5">
//                         <div className="lang-name wd-100 flex ">
//                           <label
//                             className="users__parent-info-label mb-2"
//                             htmlFor=""
//                           >
//                             Monthly Purchase Limit
//                           </label>
//                         </div>
//                         <Form.Item
//                           className="new-category__form-item"
//                           name="monthlyPurchaseLimit"
//                           rules={[{ validator: validateMonthlyPurchaseLimit }]}
//                         >
//                           <InputNumber
//                             className="w-100 d-block search__searchField py-2"
//                             placeholder="Enter monthly purchase limit"
//                             onKeyDown={handlePreventLetters}
//                             controls={false}
//                             keyboard={false}
//                           />
//                         </Form.Item>
//                       </div>
//                     </Col>
//                     <Col span={24}>
//                       <PrimaryButton
//                         buttonName={"Submit"}
//                         loading={isMonthlyPurchaseLimitSubmitting}
//                         type="submit"
//                         disableMe={loading}
//                       />
//                     </Col>
//                   </Row>
//                 </Form>
//               </section>
//               <section className="mb-5">
//                 <Form
//                   form={monthlyPurchaseLimitForSalesForm}
//                   className="px-lg-5 px-2"
//                   onFinish={handleSubmitMonthlyPurchaseLimitForSales}
//                   initialValues={{ monthlyPurchaseLimitForSales: "" }}
//                 >
//                   <Row gutter={24}>
//                     <Col span={24}>
//                       <div className="new-actor__name new-category mb-5">
//                         <div className="lang-name wd-100 flex ">
//                           <label
//                             className="users__parent-info-label mb-2"
//                             htmlFor=""
//                           >
//                             Monthly Purchase Limit For Sales
//                           </label>
//                         </div>
//                         <Form.Item
//                           className="new-category__form-item"
//                           name="monthlyPurchaseLimitForSales"
//                           rules={[
//                             { validator: validateMonthlyPurchaseLimitForSales },
//                           ]}
//                         >
//                           <InputNumber
//                             className="w-100 d-block search__searchField py-2"
//                             placeholder="Enter monthly purchase limit for sales"
//                             onKeyDown={handlePreventLetters}
//                             controls={false}
//                             keyboard={false}
//                           />
//                         </Form.Item>
//                       </div>
//                     </Col>
//                     <Col span={24}>
//                       <PrimaryButton
//                         buttonName={"Submit"}
//                         loading={isMonthlyPurchaseLimitForSalesSubmitting}
//                         type="submit"
//                         disableMe={loading}
//                       />
//                     </Col>
//                   </Row>
//                 </Form>
//               </section>
//             </Spin>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Settings;
import { useEffect, useState } from "react";
import { Spin } from "antd";
import { getSettings } from "../../Network";
import { toastError } from "../../helpers/toasters";

import Header from "modules/SubComponents/Header";
import SettingItem from "./SettingItem";

const Settings = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    setLoading(true);
    getSettings(
      (res) => {
        setLoading(false);
        if (res.success) {
          setData(res.data || []);
        } else {
          toastError(res.message);
        }
      },
      (res) => {
        setLoading(false);
        toastError(res?.message || res?.data?.error);
      },
    );
  }, []);

  return (
    <section className="users">
      <div className="users__all-contents">
        <div className="users__content">
          <div className="users__usersData align-items-stretch">
            <Header title="Settings" />
            <Spin className="w-100 d-block" spinning={loading}>
              {data.map((item) => (
                <SettingItem key={item.id} item={item} />
              ))}
            </Spin>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Settings;
